import { applyMove, type GameState } from "../sortaballs-8-colors/logic"

// Applies the first `count` of a puzzle's correct moves to its initial board,
// producing the board as it stands N moves in. Used when accepting a challenge
// whose opponent revealed (hinted) N moves — the acceptor starts from there.
export function advanceBoard(
  state: GameState,
  moves: { from: number; to: number }[],
  count: number,
): GameState {
  const limit = Math.max(0, Math.min(count, moves.length))
  return moves
    .slice(0, limit)
    .reduce<GameState>((board, move)=> applyMove(board, move), state)
}
